import { render, staticRenderFns } from "./traineePreassessment.vue?vue&type=template&id=47d5f840&scoped=true"
import script from "./traineePreassessment.vue?vue&type=script&lang=js"
export * from "./traineePreassessment.vue?vue&type=script&lang=js"
import style0 from "./traineePreassessment.vue?vue&type=style&index=0&id=47d5f840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d5f840",
  null
  
)

export default component.exports